<footer class="footer">
  <div class="row align-items-center justify-content-xl-between">
    <div class="col-xl-6">
      <div class="copyright text-center text-xl-left text-muted">
        &copy; {{ test | date: "yyyy" }} <a href="https://www.ecarga.com.ph/" class="font-weight-bold ml-1" target="_blank">EEI Carga Digital Logistics Corp.</a>
      </div>
    </div>
    <!-- <div class="col-xl-6">
      <ul class="nav nav-footer justify-content-center justify-content-xl-end">
        <li class="nav-item">
          <a href="https://www.ecarga.com.ph/about.html" class="nav-link" target="_blank">About Us</a>
        </li>
        <li class="nav-item">
          <a href="https://www.ecarga.com.ph/services.html" class="nav-link" target="_blank">Services</a>
        </li>
      </ul>
    </div> -->
  </div>
</footer>
